module.exports = __webpack_public_path__ + "img/banner1.f03882a7.jpg";